module.exports = {"closeButtonText":"Kapat","thumbNailAlt":"Görüntüyü Önizle","next":"Sonraki Sayfa","previous":"Önceki sayfa","addNote":"Bir not ekle..."}


//////////////////
// WEBPACK FOOTER
// ./translations/tr.json
// module id = 28
// module chunks = 0